import styled from "styles/styled_components";

const StyledError = styled.div`
  color: ${(props) => props.theme.colors.error};
  font-family: ${(props) => props.theme.text.primaryFamily};
  padding-top: ${(props) => props.theme.spacing.small};
  text-align: left;
`;

export default StyledError;
